import { ConstructorPageType } from '@lentau/constructor/shared/constants';

export const LazyLoadEarlyConstructorRequestSSR: (page: ConstructorPageType) => Promise<() => void> = (
  page: ConstructorPageType
) => import('./early-request.ssr').then((m) => () => m.constructorRequestSSR(page));
